import { createTheme } from '@material-ui/core';
import { fuseDark, skyBlue, newColor } from './colors';
import { red } from '@material-ui/core/colors';

export const leftLayoutTheme = createTheme({
  palette: {
    type: 'light',
    primary: fuseDark,
    secondary: {
      light: skyBlue[100],
      main: skyBlue[500],
      dark: skyBlue[900],
    },
    text: {
      primary: newColor[10],
      secondary: newColor[5],
    },
    background: {
      paper: fuseDark[900],
      default: newColor[15],
    },
    error: red,
  },
  overrides: {
    MuiSvgIcon: {
      root: {
        color: newColor[10],
      },
    },
  },
});
